import React from 'react';
export function ProblemSection() {
  const problems = ['Dudás en qué hacer en situaciones clínicas', 'Tenés miedo de equivocarte', 'Sentís que te faltan herramientas reales', 'En la guardia todo pasa rápido y te desborda', 'Estudiás… pero no sabés cómo aplicarlo'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-239">
      <div className="max-w-xl mx-auto" data-id="element-240">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-241">
          😩 ¿Te pasa esto en la práctica?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-242">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-243">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-244">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-245">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-246">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-247">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-248">
            ¿Cuánto tiempo más vas a seguir trabajando así?
          </h3>
        </div>
      </div>
    </section>;
}